import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsTabletMQ } from 'core/modules/MediaQueries/selectors';
import { isChrome, isEdge } from 'core/utils/helpers/browser';

import { selectSiteUrl } from 'core/selectors/app';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ChromeRating from 'core/modules/Partials/ChromeRating/ChromeRating';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import { triggerButtonBenefitsIsViewed } from './actions';

import './HomeButtonBenefits.scss';
import config from './configs';

function HomeButtonBenefits() {
  const {
    buttonHeader, buttonDescription, buttonCopy, buttonImage,
  } = config;

  const siteUrl = useSelector(selectSiteUrl);
  const isTablet = useSelector(selectIsTabletMQ);
  const dispatch = useDispatch();

  const shouldShowButtonLink = !isTablet && (isChrome || isEdge);

  useEffect(() => {
    if (shouldShowButtonLink) {
      dispatch(triggerButtonBenefitsIsViewed());
    }
  }, [shouldShowButtonLink, dispatch]);

  return (
    <div className="mn_buttonBenefits">
      <ContentWrap>
        <div className="mn_row">
          <div className="mn_col-xl-5">
            <div className="mn_textWrap">
              <h2>{buttonHeader}</h2>
              <p>{buttonDescription}</p>
              <ul>
                {buttonCopy.map(buttonText => (
                  <li key={buttonText}>{buttonText}</li>
                ))}
                <li className="mn_chromeRating">
                  <ChromeRating />
                </li>
              </ul>
              {shouldShowButtonLink && <a className="mn_button" href={`${siteUrl}/button`}>Get the button</a>}
            </div>
          </div>
          <div className="mn_col-xl-1" />
          <div className="mn_col-xl-6">
            <div className="mn_imageWrap">
              <img src={buttonImage} alt="" />
            </div>
          </div>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><HomeButtonBenefits {...props} /></ComponentErrorBoundary>;
